import CreateUsuario from '@/features/users/components/create-usuario'

export function CadastrarParceiroPage() {
  return <CreateUsuario />
}
